import {
  ITableSortLabel,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  ITypography,
  Typography
} from '@sanlam-glacier/app-common/components';
import clsx from 'clsx';
import styles from './regulation-28-table.module.scss';
import {
  Reg28TableHeaderConfig,
  TableHeaderProps
} from '../../../types/regulation-28/regulation-28-table.type';

export const Regulation28TableHeader = <T,>({
  headers,
  handleSort,
  align,
  tableHeaderClassName,
  disabled,
  actionHeaderKey,
  hoverable,
  sticky
}: TableHeaderProps<T>) => {
  const testComponentName = 'regulation28';

  const hasSortHandler = !!handleSort;

  const getCellAlignment = (header: Reg28TableHeaderConfig<T>) => {
    if (header.align === 'left') return TableCell.ALIGN.LEFT;
    if (header.align === 'right') return TableCell.ALIGN.RIGHT;
  };

  const getTypographyAlignment = (header: Reg28TableHeaderConfig<T>) => {
    if (header.align === 'left') return Typography.ALIGN.LEFT;
    if (header.align === 'right') return Typography.ALIGN.RIGHT;
  };

  const getSortLabelAlignmentClass = (header: Reg28TableHeaderConfig<T>) => {
    if (header.align === 'right') return 'table-cell-sort-right';
    return '';
  };

  return (
    <TableHead data-testid={`${testComponentName}TableHead`} sticky={sticky}>
      <TableRow className={tableHeaderClassName} disabled={disabled} hoverable={hoverable}>
        {headers.map((header, index) => (
          <TableCell
            data-testid={`${testComponentName}${header.label}ColHeader`}
            key={(header.key as string) ?? index}
            align={getCellAlignment(header) ?? align}
            variant={TableCell.VARIANT.HEAD}
            className={`inner-header-cell ${header.className} ${
              header.key && header.key === actionHeaderKey ? 'table-action-column' : ''
            }`}
          >
            {header.renderCellContent ? (
              header.renderCellContent()
            ) : hasSortHandler && header.key ? (
              <TableSortLabel
                data-testid={`${testComponentName}${header.label}ColHeaderSortBtn`}
                className={clsx(
                  `${tableHeaderClassName} ${getSortLabelAlignmentClass(header)}`,
                  styles.tableHeaders
                )}
                active={hasSortHandler}
                direction={header.direction as unknown as ITableSortLabel['direction']}
                onClick={() => handleSort(header.key, header.direction)}
              >
                <HeaderLabel
                  data-testid={`${testComponentName}${header.label}ColHeaderLabel`}
                  title={header.label}
                >
                  {header.label}
                </HeaderLabel>
              </TableSortLabel>
            ) : (
              <HeaderLabel
                data-testid={`${testComponentName}${header.label}ColHeaderLabel`}
                align={getTypographyAlignment(header)}
                title={header.label}
              >
                {header.label}
              </HeaderLabel>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

type HeaderProps = {
  children: string;
  align?: ITypography['align'];
  title?: string;
};
const HeaderLabel = ({ children, align, title }: HeaderProps) => (
  <Typography
    weight={Typography.WEIGHT.MEDIUM}
    variant={Typography.VARIANT.B3}
    color={Typography.COLOR.SECONDARY}
    className={`table-header-label`}
    align={align}
    title={title}
  >
    {children}
  </Typography>
);
